export const initialState = () => ({
    templates: [],
    activeTemplateUuid: null
});

export const state = initialState();